import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SEO from '../components/common/SEO';
import { useHydrated } from '../hooks/useHydrated';
import { useTranslation } from '../hooks/useTranslation';
import './TeluguFestivals.css';

const teluguFestivalData = [
  {
    month: 'January',
    teluguMonth: 'Pushyam / Magham',
    festivals: [
      { date: 'Jan 3', name: 'Pushya Purnima', type: 'Purnima' },
      { date: 'Jan 6', name: 'Sankashti Chaturthi', type: 'Vrat' },
      { date: 'Jan 14', name: 'Makara Sankranti / Pongal', type: 'Major' },
      { date: 'Jan 15', name: 'Kanuma', type: 'Major' },
      { date: 'Jan 16', name: 'Mukkanuma', type: 'Festival' },
      { date: 'Jan 23', name: 'Vasant Panchami (Saraswati Puja)', type: 'Major' },
      { date: 'Jan 25', name: 'Ratha Saptami', type: 'Festival' },
    ],
  },
  {
    month: 'February',
    teluguMonth: 'Magham / Phalgunam',
    festivals: [
      { date: 'Feb 1', name: 'Magha Purnima', type: 'Purnima' },
      { date: 'Feb 13', name: 'Vijaya Ekadashi', type: 'Ekadashi' },
      { date: 'Feb 15', name: 'Maha Shivaratri', type: 'Major' },
      { date: 'Feb 17', name: 'Phalguna Amavasya', type: 'Amavasya' },
    ],
  },
  {
    month: 'March',
    teluguMonth: 'Phalgunam / Chaitram',
    festivals: [
      { date: 'Mar 3', name: 'Phalguna Purnima', type: 'Purnima' },
      { date: 'Mar 3', name: 'Holika Dahan', type: 'Major' },
      { date: 'Mar 4', name: 'Holi', type: 'Major' },
      { date: 'Mar 19', name: 'Ugadi (Telugu New Year)', type: 'Major' },
      { date: 'Mar 21', name: 'Gauri Puja', type: 'Festival' },
      { date: 'Mar 27', name: 'Sri Rama Navami', type: 'Major' },
    ],
  },
  {
    month: 'April',
    teluguMonth: 'Chaitram / Vaisakham',
    festivals: [
      { date: 'Apr 2', name: 'Chaitra Purnima (Hanuman Jayanti)', type: 'Major' },
      { date: 'Apr 13', name: 'Varuthini Ekadashi', type: 'Ekadashi' },
      { date: 'Apr 20', name: 'Akshaya Tritiya', type: 'Major' },
      { date: 'Apr 27', name: 'Mohini Ekadashi', type: 'Ekadashi' },
    ],
  },
  {
    month: 'May',
    teluguMonth: 'Vaisakham / Jyeshtham',
    festivals: [
      { date: 'May 1', name: 'Vaishakha Purnima (Buddha Purnima)', type: 'Purnima' },
      { date: 'May 13', name: 'Apara Ekadashi', type: 'Ekadashi' },
      { date: 'May 16', name: 'Jyeshtha Amavasya', type: 'Amavasya' },
      { date: 'May 17', name: 'Adhika Masam Begins', type: 'Special' },
    ],
  },
  {
    month: 'June',
    teluguMonth: 'Jyeshtham / Ashadham',
    festivals: [
      { date: 'Jun 15', name: 'Ashadha Amavasya (Adhika Masam Ends)', type: 'Amavasya' },
      { date: 'Jun 25', name: 'Nirjala Ekadashi', type: 'Ekadashi' },
      { date: 'Jun 29', name: 'Ashadha Purnima (Guru Purnima)', type: 'Purnima' },
    ],
  },
  {
    month: 'July',
    teluguMonth: 'Ashadham / Shravanam',
    festivals: [
      { date: 'Jul 10', name: 'Yogini Ekadashi', type: 'Ekadashi' },
      { date: 'Jul 16', name: 'Jagannath Rath Yatra', type: 'Major' },
      { date: 'Jul 25', name: 'Devshayani Ekadashi', type: 'Ekadashi' },
      { date: 'Jul 29', name: 'Guru Purnima', type: 'Purnima' },
    ],
  },
  {
    month: 'August',
    teluguMonth: 'Shravanam / Bhadrapadam',
    festivals: [
      { date: 'Aug 9', name: 'Kamika Ekadashi', type: 'Ekadashi' },
      { date: 'Aug 18', name: 'Naga Panchami', type: 'Major' },
      { date: 'Aug 21', name: 'Varalakshmi Vratam', type: 'Vrat' },
      { date: 'Aug 26', name: 'Sravana Purnima (Raksha Bandhan)', type: 'Purnima' },
      { date: 'Aug 28', name: 'Gayathri Japam', type: 'Festival' },
    ],
  },
  {
    month: 'September',
    teluguMonth: 'Bhadrapadam / Ashwayujam',
    festivals: [
      { date: 'Sep 4', name: 'Krishna Janmashtami', type: 'Major' },
      { date: 'Sep 7', name: 'Aja Ekadashi', type: 'Ekadashi' },
      { date: 'Sep 14', name: 'Vinayaka Chavithi (Ganesh Chaturthi)', type: 'Major' },
      { date: 'Sep 22', name: 'Parivartini Ekadashi', type: 'Ekadashi' },
      { date: 'Sep 27', name: 'Pitru Paksha Begins', type: 'Special' },
    ],
  },
  {
    month: 'October',
    teluguMonth: 'Ashwayujam / Kartikam',
    festivals: [
      { date: 'Oct 10', name: 'Mahalaya Amavasya', type: 'Amavasya' },
      { date: 'Oct 12', name: 'Sharad Navaratri Begins', type: 'Major' },
      { date: 'Oct 16', name: 'Saraswati Puja', type: 'Festival' },
      { date: 'Oct 18', name: 'Durga Ashtami', type: 'Major' },
      { date: 'Oct 20', name: 'Vijayadashami (Dussehra)', type: 'Major' },
      { date: 'Oct 29', name: 'Karva Chauth', type: 'Vrat' },
    ],
  },
  {
    month: 'November',
    teluguMonth: 'Kartikam / Margashiram',
    festivals: [
      { date: 'Nov 5', name: 'Rama Ekadashi', type: 'Ekadashi' },
      { date: 'Nov 6', name: 'Dhanteras', type: 'Major' },
      { date: 'Nov 7', name: 'Naraka Chaturdashi', type: 'Major' },
      { date: 'Nov 8', name: 'Deepavali (Lakshmi Puja)', type: 'Major' },
      { date: 'Nov 10', name: 'Govardhan Puja', type: 'Major' },
      { date: 'Nov 11', name: 'Bhai Dooj', type: 'Major' },
      { date: 'Nov 20', name: 'Karthika Purnima', type: 'Purnima' },
      { date: 'Nov 24', name: 'Karthika Deepam', type: 'Major' },
    ],
  },
  {
    month: 'December',
    teluguMonth: 'Margashiram / Pushyam',
    festivals: [
      { date: 'Dec 4', name: 'Utpanna Ekadashi', type: 'Ekadashi' },
      { date: 'Dec 8', name: 'Margashira Amavasya', type: 'Amavasya' },
      { date: 'Dec 19', name: 'Geeta Jayanti', type: 'Major' },
      { date: 'Dec 20', name: 'Mukkoti Ekadashi (Vaikunta Ekadashi)', type: 'Ekadashi' },
      { date: 'Dec 23', name: 'Margashira Purnima', type: 'Purnima' },
    ],
  },
];

const typeColors = {
  Major: '#e65100',
  Ekadashi: '#1565c0',
  Vrat: '#6a1b9a',
  Purnima: '#f9a825',
  Amavasya: '#37474f',
  Festival: '#2e7d32',
  Special: '#c62828',
};

const typeLabels = ['All', 'Major', 'Ekadashi', 'Vrat', 'Purnima', 'Amavasya', 'Festival', 'Special'];

const TeluguFestivals = () => {
  const currentYear = new Date().getFullYear();
  const [filter, setFilter] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');
  const hydrated = useHydrated();
  const { t } = useTranslation();

  const typeTranslations = {
    All: t('teluguFestivals.all'),
    Major: t('teluguFestivals.major'),
    Ekadashi: t('teluguFestivals.ekadashi'),
    Vrat: t('teluguFestivals.vrat'),
    Purnima: t('teluguFestivals.purnima'),
    Amavasya: t('teluguFestivals.amavasya'),
    Festival: t('teluguFestivals.festivalType'),
    Special: t('teluguFestivals.special'),
  };

  const filteredData = teluguFestivalData
    .map((monthData) => ({
      ...monthData,
      festivals: monthData.festivals.filter((f) => {
        const matchesFilter = filter === 'All' || f.type === filter;
        const matchesSearch =
          f.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          f.date.toLowerCase().includes(searchTerm.toLowerCase());
        return matchesFilter && matchesSearch;
      }),
    }))
    .filter((monthData) => monthData.festivals.length > 0);

  const totalFestivals = filteredData.reduce((sum, m) => sum + m.festivals.length, 0);

  return (
    <div className="telugu-festivals-page">
      <SEO
        title={`Telugu Festivals ${currentYear} - Complete Calendar with Dates | Telugu Panchangam`}
        description={`Complete list of Telugu festivals in ${currentYear} with dates. Includes Ugadi, Makara Sankranti, Sri Rama Navami, Vinayaka Chavithi, Dussehra, Deepavali, and all major Andhra Pradesh & Telangana festivals.`}
        keywords={`telugu festivals ${currentYear}, telugu calendar ${currentYear}, ugadi ${currentYear}, makara sankranti ${currentYear}, vinayaka chavithi ${currentYear}, telugu panchangam, andhra pradesh festivals, telangana festivals`}
        canonicalPath="/telugu-festivals"
        jsonLd={[
          {
            '@context': 'https://schema.org',
            '@type': 'CollectionPage',
            'name': `Telugu Festivals ${currentYear} - Complete Calendar with Dates`,
            'description': `Complete list of Telugu festivals in ${currentYear} with dates, covering Ugadi, Sankranti, Navaratri, Deepavali and all major Andhra Pradesh & Telangana festivals.`,
            'url': 'https://www.parithi.com/telugu-festivals',
          },
          {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: 'When is Ugadi celebrated in 2026?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Ugadi, the Telugu New Year, is celebrated on March 19, 2026. It marks the beginning of a new Hindu lunar calendar year and is celebrated with the preparation of Ugadi Pachadi, a dish made with six flavours representing the different experiences of life. The new year name for 2026-27 is based on the 60-year cycle of the Telugu calendar.',
                },
              },
              {
                '@type': 'Question',
                name: 'What is the difference between Ugadi and other Indian New Year celebrations?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Ugadi is the New Year for Telugu and Kannada-speaking people, falling on Chaitra Shukla Pratipada (the first day of the Chaitra month). It coincides with Gudi Padwa (Maharashtra) and Navreh (Kashmir). Tamil New Year (Puthandu) falls on April 14 based on the solar calendar, while the Bengali New Year (Poila Boishakh) and Punjabi New Year (Baisakhi) fall on April 14-15.',
                },
              },
              {
                '@type': 'Question',
                name: 'What are the major Telugu festivals unique to Andhra Pradesh and Telangana?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Several festivals have unique regional significance in Telugu states: Bathukamma (a floral festival celebrated for 9 days during Navaratri in Telangana), Bonalu (celebrated in Hyderabad and Telangana in honour of Goddess Mahankali during Ashada month), Sammakka Sarakka Jatara (one of Asia\'s largest tribal festivals held in Medaram, Telangana), and Kanuma/Mukkanuma (the 2nd and 3rd days of Sankranti, especially important in rural Andhra Pradesh).',
                },
              },
              {
                '@type': 'Question',
                name: 'What is Mukkoti Ekadashi and why is it special?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Mukkoti Ekadashi, also known as Vaikunta Ekadashi, is the most significant Ekadashi for Telugu people, observed during the Shukla Paksha of Margashira month (December). It is believed that the gates of Vaikuntam (Lord Vishnu\'s abode) open on this day. Devotees observe strict fasting and visit Vishnu temples, especially the Tirumala Tirupati Devasthanam where the Vaikunta Dwara Darshanam attracts millions of pilgrims.',
                },
              },
            ],
          },
        ]}
      />

      <div className="container">
        <motion.div
          className="page-header"
          initial={hydrated ? { opacity: 0, y: -20 } : false}
          animate={{ opacity: 1, y: 0 }}
        >
          <h1>
            {t('teluguFestivals.title')} <span className="gradient-text">{currentYear}</span>
          </h1>
          <p>{t('teluguFestivals.subtitle')}</p>
        </motion.div>

        {/* Ugadi Highlight Banner */}
        <motion.div
          className="telugu-highlight-banner"
          initial={hydrated ? { opacity: 0, scale: 0.95 } : false}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.2 }}
        >
          <span className="telugu-highlight-icon">&#9733;</span>
          <div>
            <strong>{t('teluguFestivals.ugadi')} {currentYear}</strong> — {t('teluguFestivals.ugadiBanner')}
          </div>
        </motion.div>

        {/* Search and Filter */}
        <motion.div
          className="festivals-controls"
          initial={hydrated ? { opacity: 0, y: 10 } : false}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          <div className="festivals-search">
            <input
              type="text"
              placeholder={t('teluguFestivals.searchPlaceholder')}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="festivals-search-input"
            />
          </div>
          <div className="festivals-filter-tags">
            {typeLabels.map((type) => (
              <button
                key={type}
                className={`filter-tag ${filter === type ? 'active' : ''}`}
                onClick={() => setFilter(type)}
                style={
                  filter === type && type !== 'All'
                    ? { background: typeColors[type], borderColor: typeColors[type], color: '#fff' }
                    : {}
                }
              >
                {typeTranslations[type]}
              </button>
            ))}
          </div>
          <div className="festivals-count">
            {t('teluguFestivals.showing')} {totalFestivals} {totalFestivals !== 1 ? t('teluguFestivals.festivals') : t('teluguFestivals.festival')}
          </div>
        </motion.div>

        {/* Festival Months */}
        <div className="festivals-grid">
          {filteredData.map((monthData, idx) => (
            <motion.div
              key={monthData.month}
              className="festival-month-card"
              initial={hydrated ? { opacity: 0, y: 20 } : false}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 * idx }}
            >
              <div className="month-header">
                <div>
                  <h2>{t(`months.${monthData.month}`)}</h2>
                  <span className="tamil-month-name">{monthData.teluguMonth}</span>
                </div>
                <span className="month-count">{monthData.festivals.length} {t('teluguFestivals.festivals')}</span>
              </div>
              <div className="month-festivals">
                {monthData.festivals.map((festival, fIdx) => (
                  <div key={fIdx} className="festival-row">
                    <div className="festival-date">{festival.date.split(' ')[1]}</div>
                    <div className="festival-info">
                      <span className="festival-name">{festival.name}</span>
                      <span
                        className="festival-type-badge"
                        style={{ background: typeColors[festival.type] || '#757575' }}
                      >
                        {typeTranslations[festival.type] || festival.type}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </motion.div>
          ))}
        </div>

        {filteredData.length === 0 && (
          <div className="no-results">
            <p>{t('teluguFestivals.noResults')}</p>
          </div>
        )}

        {/* Key Highlights */}
        <motion.div
          className="festivals-highlights"
          initial={hydrated ? { opacity: 0, y: 20 } : false}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
        >
          <h2>{t('teluguFestivals.keyHighlights')} {currentYear}</h2>
          <div className="highlights-grid">
            <div className="highlight-card">
              <div className="highlight-icon">&#127774;</div>
              <h3>{t('teluguFestivals.sankranti')}</h3>
              <p>January 14, {currentYear} — Harvest festival celebrating the Sun's transition into Makara Rashi. Three-day celebration with Bhogi, Sankranti, and Kanuma.</p>
            </div>
            <div className="highlight-card">
              <div className="highlight-icon">&#127878;</div>
              <h3>{t('teluguFestivals.ugadi')}</h3>
              <p>March 19, {currentYear} — Telugu New Year. Celebrated with Ugadi Pachadi, Panchanga Sravanam, and new beginnings.</p>
            </div>
            <div className="highlight-card">
              <div className="highlight-icon">&#127769;</div>
              <h3>{t('teluguFestivals.deepavali')}</h3>
              <p>November 8, {currentYear} — Festival of Lights celebrated with fireworks, diyas, and Lakshmi Puja.</p>
            </div>
            <div className="highlight-card">
              <div className="highlight-icon">&#128330;</div>
              <h3>{t('teluguFestivals.vinayakaChavithi')}</h3>
              <p>September 14, {currentYear} — Grand 10-day celebration of Lord Ganesha with elaborate pandals and immersion processions.</p>
            </div>
          </div>
        </motion.div>

        {/* Bottom SEO Content */}
        <div className="page-bottom-content">
          <h2>Telugu Festivals Calendar — Complete Guide to Andhra Pradesh & Telangana Celebrations</h2>
          <p>The Telugu festival calendar follows the traditional Hindu lunisolar Panchangam, with months named after the Nakshatras (lunar mansions). Telugu calendar months — Chaitram, Vaisakham, Jyeshtham, Ashadham, Shravanam, Bhadrapadam, Ashwayujam, Kartikam, Margashiram, Pushyam, Magham, and Phalgunam — form the foundation of Telugu festival scheduling. The year begins with Ugadi in Chaitra month.</p>

          <h3>Makara Sankranti — The Grand Telugu Harvest Festival</h3>
          <p><strong>Makara Sankranti</strong> is the biggest festival in Andhra Pradesh and Telangana, celebrated over three days. <strong>Bhogi</strong> (Day 1) involves burning old belongings in a bonfire to welcome the new. <strong>Sankranti</strong> (Day 2) is the main day when families draw colourful Muggulu (Rangoli) and prepare traditional dishes like Ariselu, Boorelu, and Pongali. <strong>Kanuma</strong> (Day 3) honours cattle and livestock. Cockfighting (now restricted) and kite flying are traditional Sankranti activities in the Telugu states.</p>

          <h3>Key Telugu Festivals Through the Year</h3>
          <p><strong>Ugadi:</strong> The Telugu and Kannada New Year, celebrated on Chaitra Shukla Pratipada. Families prepare Ugadi Pachadi with six tastes — sweet (jaggery), sour (tamarind), bitter (neem), spicy (chilli), salty, and tangy (raw mango) — representing life's varied experiences. Panchanga Sravanam (listening to the new year's almanac predictions) is an important tradition.</p>
          <p><strong>Vinayaka Chavithi:</strong> One of the most grandly celebrated festivals in the Telugu states, observed on Bhadrapada Shukla Chaturthi. Elaborate Ganesh pandals are set up across cities, especially in Hyderabad where the famous Khairatabad Ganesh idol attracts lakhs of devotees. The 10-day celebration ends with Nimajjanam (immersion).</p>
          <p><strong>Bathukamma:</strong> A unique floral festival of Telangana, celebrated for nine days during Navaratri. Women create beautiful flower stacks (Bathukamma) using seasonal wildflowers and offer them to Goddess Gauri while singing traditional songs. It culminates on Saddula Bathukamma, two days before Dussehra.</p>
          <p><strong>Bonalu:</strong> A traditional Hindu festival of Telangana, celebrated during Ashada month (July-August) in honour of Goddess Mahankali. Women carry decorated pots (Bonam) filled with cooked rice, jaggery, and curd to the Goddess's temple. The celebrations are especially grand at Golconda, Secunderabad, and Lal Darwaza temples.</p>

          <h3>Telugu Months and Their Significance</h3>
          <p>Each Telugu month has cultural and agricultural importance. <strong>Chaitram</strong> (Mar-Apr) marks the New Year with Ugadi. <strong>Shravanam</strong> (Aug-Sep) is considered the most auspicious month for marriages and Varalakshmi Vratam. <strong>Bhadrapadam</strong> (Sep-Oct) brings Vinayaka Chavithi and Krishna Janmashtami. <strong>Ashwayujam</strong> (Oct-Nov) features Navaratri and Dussehra. <strong>Kartikam</strong> (Nov-Dec) is the month of Deepavali and Karthika Deepam, with daily lamp lighting considered auspicious. <strong>Margashiram</strong> (Dec-Jan) is considered spiritually auspicious, especially for Vishnu worship and Mukkoti Ekadashi.</p>

          <h3>Frequently Asked Questions About Telugu Festivals</h3>
          <div className="faq-seo">
            <div className="faq-seo-item">
              <h4>When is Ugadi celebrated in {currentYear}?</h4>
              <p>Ugadi, the Telugu New Year, is celebrated on March 19, {currentYear}. It marks the beginning of a new Hindu lunar calendar year and is celebrated with the preparation of Ugadi Pachadi, a dish made with six flavours representing the different experiences of life.</p>
            </div>
            <div className="faq-seo-item">
              <h4>What is the difference between Ugadi and other Indian New Year celebrations?</h4>
              <p>Ugadi is the New Year for Telugu and Kannada-speaking people, falling on Chaitra Shukla Pratipada. It coincides with Gudi Padwa (Maharashtra) and Navreh (Kashmir). Tamil New Year (Puthandu) falls on April 14 based on the solar calendar, while Bengali New Year and Punjabi New Year fall on April 14-15.</p>
            </div>
            <div className="faq-seo-item">
              <h4>What are the major Telugu festivals unique to Andhra Pradesh and Telangana?</h4>
              <p>Several festivals have unique regional significance in Telugu states: Bathukamma (a floral festival celebrated during Navaratri in Telangana), Bonalu (celebrated in honour of Goddess Mahankali during Ashada month), Sammakka Sarakka Jatara (one of Asia's largest tribal festivals held in Medaram, Telangana), and Kanuma/Mukkanuma (the 2nd and 3rd days of Sankranti).</p>
            </div>
            <div className="faq-seo-item">
              <h4>What is Mukkoti Ekadashi and why is it special?</h4>
              <p>Mukkoti Ekadashi, also known as Vaikunta Ekadashi, is the most significant Ekadashi for Telugu people, observed during Margashira month (December). It is believed that the gates of Vaikuntam open on this day. Devotees visit Vishnu temples, especially the Tirumala Tirupati Devasthanam where the Vaikunta Dwara Darshanam attracts millions of pilgrims.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeluguFestivals;
